import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { canOpenTruckYardSection } from "../../../Layouts/patio-maniobras/truckYardSectionAccess";

/**
 * Guarda de ruta para las secciones del patio que un rol no puede abrir.
 * El menú ya las oculta; esto cierra el acceso por URL directa. La autorización
 * de verdad la hace el backend (hikvisionAccess.routes → denyYardOperators).
 */
export default function TruckYardRoleRoute({ section, children }: { section: string; children: ReactNode }) {
  const roleId = localStorage.getItem("userRoleId") || "";
  if (!canOpenTruckYardSection(roleId, section)) {
    return <Navigate to="/truck-yard/access" replace />;
  }
  return <>{children}</>;
}
